import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import { CustomerBranchFilterDefault } from "src/core/products/api/products.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { ILeadTimeOverride } from "src/modules/lead-time-override/api/lead-time-override.api";

interface AvailableLTOColumns {
  id: ColumnDef<ILeadTimeOverride, number>;
  deliveryDate: ColumnDef<ILeadTimeOverride, string>;
  cutoffDateTime: ColumnDef<ILeadTimeOverride, string>;
  type: ColumnDef<ILeadTimeOverride, CustomerBranchFilterDefault>;
  actions: ColumnDef<ILeadTimeOverride, unknown>,
}

export const leadTimeOverridesTableColumns = (actionButton: (info: CellContext<ILeadTimeOverride, unknown>) => React.ReactNode): Array<ColumnDef<ILeadTimeOverride, unknown>> => {
  const customColumnHelper = customCreateColumnHelper<ILeadTimeOverride>();
  const columnHelper = createColumnHelper<ILeadTimeOverride>();

  const columns: AvailableLTOColumns = {
    id: customColumnHelper.numberColumn(columnHelper, "id", {}),
    deliveryDate: customColumnHelper.dateColumn(columnHelper, "deliveryDate", { header: "Delivery Date" }),
    cutoffDateTime: customColumnHelper.dateColumn(columnHelper, "cutoffDateTime", {
      header: "Cutoff Datetime",
      format: "HH:mm on Do MMM YYYY"
    }),
    type: customColumnHelper.standardTextColumn(columnHelper, "type", {
      header: "Applicable to",
      cell: info => (
        <Text>
          {info.row.original.type === CustomerBranchFilterDefault.AllowAll ? "Everyone" : "Selected Customers"}
        </Text>
      )
    }),
    actions: customColumnHelper.actionColumn(columnHelper, actionButton, {})
  };

  return Object.values(columns);
};
